import React from "react";
import { Highlight } from "./Highlight";

interface FormattedMessageProps {
  content: string;
}

export const FormattedMessage: React.FC<FormattedMessageProps> = ({
  content,
}) => {
  // Parse **bold** text and convert to Highlight components
  const parseBoldText = (text: string) => {
    const parts = text.split(/(\*\*.*?\*\*)/);

    return parts.map((part, index) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        const boldText = part.replace(/\*\*/g, "");
        return <Highlight key={index}>{boldText}</Highlight>;
      }
      return part;
    });
  };

  return <>{parseBoldText(content)}</>;
};
